import { createStore, createLogger } from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import setting from './setting';
import auth from './modules/auth'; // Import the auth module
const debug = process.env.NODE_ENV !== 'production';

export default createStore({
  state: {
    shareOffcanvas: false,
    user: null,
    showMfaPrompt: false,
    mfaEnabled: false,
    isTrainingUser: false,
    profilePhotoURL: '',
    assessmentUserResponses: [],
    assessmentReviewUserResponses: [],
    colors: {
      appGreen: '#49eb34', // Assessment Target color
      appRed: '#fc0505',
      appOrange: '#fc7c05', //ESS assessment color
      appYellow: '#dffc05',
      appBlue: '#05b2fc', // Client assessment color
      appWhite: '#fff',
      appBlack: '#000',
      appPrimary: '#7F2628',
      appGrey: '#54575A',
      appLightGrey: '#e9e9e9',
      appWhite100: '#f8f8f8',
    },
    selectedOrg: null,
    selectedAssessment: null,
    filteredAssessments: [],
    assessments: [],
    organisations: [],
    currentSection: '',
    questions: [], // cache for all questions
  },
  getters,
  mutations,
  actions,
  modules: {
    setting,
    auth,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
